import { RelayPaginationNav } from './RelayPagination';
import {DEFAULT_PAGE_SIZE} from "../const";

export type RelayPaginationParams = {
    first: number;
    after: string;
};

export class RelayPaginationState {
    size: number;
    after: string;

    constructor(after: string = '0', size: number = DEFAULT_PAGE_SIZE) {
        this.size = size;
        this.after = after;
    }

    newPage (totalRecords: number, nav: RelayPaginationNav) {
        const { size, after } = this;

        let lastPageAfter = Math.floor(totalRecords / size) * size;
        if (lastPageAfter === totalRecords) {
            lastPageAfter = totalRecords - size;
        }

        let newAfter: string;

        switch (nav) {
            case RelayPaginationNav.FIRST_PAGE:
                newAfter = '0';
                break;
            case RelayPaginationNav.LAST_PAGE:
                newAfter = lastPageAfter.toString();
                break;
            case RelayPaginationNav.NEXT_PAGE:
                newAfter = (Math.min(lastPageAfter, Number(after) + size)).toString();
                break;
            case RelayPaginationNav.PREV_PAGE:
                newAfter = (Math.max(0, Number(after) - size)).toString();
                break;
            default:
                newAfter = after;
        }

        return new RelayPaginationState(newAfter, size);
    }

    newPageSize(newPageSize: number) {
        if (newPageSize != null) {
            return new RelayPaginationState(this.after, newPageSize);
        }
        return this;
    }

    toGraphQlParams (): RelayPaginationParams {
        return {
            first: this.size,
            after: this.after
        };
    }
}
